"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ordersFetch = void 0;
const fluture_1 = require("fluture");
const isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
const monet_1 = require("monet");
const perimeterX_1 = __importDefault(require("../perimeterX"));
const commercetools_1 = require("../secrets/commercetools");
const fluture_utils_1 = require("../utils/fluture-utils");
/** @deprecated **/
const ordersFetch = (request) => {
    const fetchOptions = {
        body: JSON.stringify(request),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: 'POST'
    };
    return (0, fluture_1.attemptP)(() => (0, isomorphic_fetch_1.default)(commercetools_1.orderUrl, fetchOptions))
        .pipe(fluture_utils_1.verifyResponse)
        .pipe((0, fluture_1.chain)(fluture_utils_1.attemptBody))
        .pipe((0, fluture_1.map)(monet_1.Maybe.fromNull))
        .pipe((0, fluture_1.chainRej)(perimeterX_1.default));
};
exports.ordersFetch = ordersFetch;
//# sourceMappingURL=orders.js.map